var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    !_vm.showQuestions
      ? _c("form", { attrs: { "data-vv-scope": "user" } }, [
          _c("div", { staticClass: "row mt-3" }, [
            _c(
              "div",
              { staticClass: "col-6 mt-2" },
              [
                _c("vs-input", {
                  staticClass: "w-100 cursor-default",
                  attrs: {
                    autocomplete: "off",
                    label: "Rut",
                    maxlength: "12",
                    name: "iut",
                    readonly: ""
                  },
                  model: {
                    value: _vm.cuUserData.iut,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "iut", $$v)
                    },
                    expression: "cuUserData.iut"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 mt-2" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    label: "Nombres",
                    maxlength: "250",
                    name: "name",
                    danger: _vm.errors.has("user.name"),
                    "danger-text": _vm.errors.first("user.name")
                  },
                  model: {
                    value: _vm.cuUserData.name,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "name", $$v)
                    },
                    expression: "cuUserData.name"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 mt-2" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    label: "Apellido Paterno",
                    maxlength: "200",
                    name: "lastName",
                    danger: _vm.errors.has("user.lastName"),
                    "danger-text": _vm.errors.first("user.lastName")
                  },
                  model: {
                    value: _vm.cuUserData.lastName,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "lastName", $$v)
                    },
                    expression: "cuUserData.lastName"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 mt-2" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    label: "Apellido Materno",
                    maxlength: "250",
                    name: "mothersLastName"
                  },
                  model: {
                    value: _vm.cuUserData.mothersLastName,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "mothersLastName", $$v)
                    },
                    expression: "cuUserData.mothersLastName"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 mt-2" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    label: "Número Documento / Número de serie",
                    maxlength: "200",
                    name: "iutNumber",
                    danger: _vm.errors.has("user.iutNumber"),
                    "danger-text": _vm.errors.first("user.iutNumber")
                  },
                  model: {
                    value: _vm.cuUserData.iutNumber,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "iutNumber", $$v)
                    },
                    expression: "cuUserData.iutNumber"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 mt-2" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    label: "Correo Personal",
                    maxlength: "250",
                    name: "email",
                    danger: _vm.errors.has("user.email"),
                    "danger-text": _vm.errors.first("user.email")
                  },
                  model: {
                    value: _vm.cuUserData.email,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "email", $$v)
                    },
                    expression: "cuUserData.email"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 mt-2" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    label: "Comuna",
                    maxlength: "100",
                    name: "commune",
                    danger: _vm.errors.has("user.commune"),
                    "danger-text": _vm.errors.first("user.commune")
                  },
                  model: {
                    value: _vm.cuUserData.commune,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "commune", $$v)
                    },
                    expression: "cuUserData.commune"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6 mt-2" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|numeric",
                      expression: "'required|numeric'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    label: "Teléfono móvil",
                    maxlength: "25",
                    name: "phone",
                    danger: _vm.errors.has("user.phone"),
                    "danger-text": _vm.errors.first("user.phone")
                  },
                  model: {
                    value: _vm.cuUserData.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "phone", $$v)
                    },
                    expression: "cuUserData.phone"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "text-right mt-4" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", disabled: _vm.loading },
                  on: { click: _vm.submitForm }
                },
                [_vm._v(" Continuar verificación ")]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.showQuestions
      ? _c(
          "div",
          [
            _c("h5", { staticClass: "mb-4" }, [
              _vm._v("Preguntas de verificación de identidad")
            ]),
            _c("p", { staticClass: "text-muted mb-4" }, [
              _vm._v(
                "Responda las siguientes preguntas para confirmar su identidad."
              )
            ]),
            _vm._l(_vm.securityQuestions, function(pregunta, key) {
              return _c(
                "div",
                { key: key, staticClass: "mb-4" },
                [
                  _c("label", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(pregunta.text || key))
                  ]),
                  _c("b-form-radio-group", {
                    staticClass: "mt-2",
                    attrs: {
                      options: _vm.formatOptions(
                        pregunta.opciones || pregunta.options
                      ),
                      stacked: ""
                    },
                    model: {
                      value: _vm.answers[key],
                      callback: function($$v) {
                        _vm.$set(_vm.answers, key, $$v)
                      },
                      expression: "answers[key]"
                    }
                  })
                ],
                1
              )
            }),
            _c(
              "div",
              { staticClass: "text-right mt-4" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "primary",
                      disabled: _vm.loading || !_vm.allQuestionsAnswered
                    },
                    on: { click: _vm.submitAnswers }
                  },
                  [_vm._v(" Verificar y generar certificado ")]
                )
              ],
              1
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }